/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * 
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 * 
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

import { LOGGED_IN, LOGGED_OUT } from "../actions/index";

export default function (state, action) {
    switch (action.type) {
        case LOGGED_IN:
            localStorage.setItem('TOKEN', action.payload.data.token);
            return localStorage.getItem('TOKEN') === "null" || localStorage.getItem('TOKEN') === null ? "" : localStorage.getItem('TOKEN');
        case LOGGED_OUT:
            const language_loaded = localStorage.getItem('language-loaded');
            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem('language-loaded', language_loaded);
            return localStorage.getItem('TOKEN') === "null" || localStorage.getItem('TOKEN') === null ? "" : localStorage.getItem('TOKEN');
        default:
            return localStorage.getItem('TOKEN') === "null" || localStorage.getItem('TOKEN') === null ? "" : localStorage.getItem('TOKEN');
    }
}
